// extracted by mini-css-extract-plugin
export var bottomWave = "Q_cT";
export var container = "Q_b";
export var footerText = "Q_cj";
export var middleWave = "Q_cS";
export var section = "Q_d";
export var subtitle = "Q_cV";
export var textContainer = "Q_cq";
export var title = "Q_h";